export const FrequentlyBoughtTogetherTypeEnum = {
  Item: 1,
  Wall: 2,
  Tooling: 3,
};

export default FrequentlyBoughtTogetherTypeEnum;
